import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL, getCacheBuster } from './utils';

const ID = '2';
const IABid = [10];

export const createPixel = (): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  const redirect = getUserSyncURL(ID);
  iframe.src = `https://ssum-sec.casalemedia.com/usermatch?r=${getCacheBuster()}&s=181869&cb=${redirect}`;

  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    const iframe = createPixel();
    fastdom.mutate(function userSyncCasalemediaAddElement() {
      document.body.appendChild(iframe);
    });
  }),
);
